/**
 * @packageDocumentation
 * @module f1/adt
 */

import { t_rec_open } from '../types';

export interface Key {
  /**
   * Get the key of a dictionary
   *
   * @public
   * @alias f1.key
   * @param index index in to the value
   * @param value select a single value from this element
   * @example
   *
   * ```ts
   * key('3', { '3': 4 }) === 4
   * ```
   */
  <K extends number | string, V extends t_rec_open, R>(index: K, value: V): R;
  /**
   * {@link FnKeyValue}
   * @param value
   */
  <K extends number | string, V extends t_rec_open, R>(index: K): (value: V) => R;
}

/**
 * @see Key
 */
export default (index: number | string, value: t_rec_open) => value[index];
